'use client'
import { useRowLabel } from '@payloadcms/ui'

export function SubmissionRowLabel() {
  const { data } = useRowLabel<{ field?: string; value?: string }>()
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '999px',
        backgroundColor: '#1a1a2e',
        color: '#ffffff',
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
      }}
    >
      {data?.field ?? 'Feld'}
    </span>
  )
}
